"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MessageIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-527.000000, -130.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(539.000000, 138.000000) rotate(-360.000000) translate(-539.000000, -138.000000) translate(527.000000, 130.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M22.1538462,2.9262764 L13.1690544,10.0052032 C12.531498,10.5075204 11.6320905,10.5389152 10.9618028,10.0993877 L10.8309456,10.0052032 L1.84615385,2.9262764 L1.84615385,14.2222222 L22.1538462,14.2222222 L22.1538462,2.9262764 Z M3.30386363,1.77777778 L12,8.62927916 L20.6961364,1.77777778 L3.30386363,1.77777778 Z M22.5784615,0 C23.3635556,0 24,0.612872431 24,1.36888889 L24,14.6311111 C24,15.3871276 23.3635556,16 22.5784615,16 L1.42153846,16 C0.636444448,16 0,15.3871276 0,14.6311111 L0,1.36888889 C0,0.612872431 0.636444448,0 1.42153846,0 L22.5784615,0 Z"
        })
      })
    })
  })]
});

MessageIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = MessageIcon;
exports.default = _default;